<template>
  <div
    :class="$style.root"
  >
    <LayoutThumbnailContentComponent>
      <template #image>
        <div
        v-if="attributes?.coverImage?.data?.attributes"
        :class="$style.coverImage"
      >
          <i18nLink :to="routeObject">
            <CoreImageComponent
              :image="attributes?.coverImage?.data?.attributes"
            />
          </i18nLink>
        </div>
      </template>
      <template #content>
        <i18nLink
          :to="routeObject"
          :class="$style.link"
        >
          <div :class="$style.title">
            {{ attributes?.title?.trim() }}
          </div>

          <div
            v-if="attributes?.projectCategories?.data?.length"
            :class="$style.categories"
          >
            {{ attributes?.projectCategories?.data?.map((category) => category?.attributes?.label)?.filter(Boolean)?.join(', ') }}
          </div>

          <SharedProjectsDatesComponent
            v-if="attributes?.dateStart"
            :dateStart="attributes?.dateStart"
            :dateEnd="attributes?.dateEnd"
            :ongoing="attributes?.ongoing"
            :hideMonths="attributes?.hideMonths"
            :hideDays="attributes?.hideDays"
          />
        </i18nLink>
      </template>
    </LayoutThumbnailContentComponent>
  </div>
</template>

<script lang="ts" setup>
  const props = defineProps({
    data: Object
  })

  const localizedData = baseStrapiGetLocalizedData(props.data)
  const attributes = baseStrapiGetAttributes(localizedData)

  const routeObject = { name: 'projects-slug', params: { slug: attributes?.slug } }
</script>

<style module>
.root {
}

.root:hover,
.root:hover * {
  color: var(--color--magenta);
}

.title {
  composes: reset-heading from global;
  text-transform: uppercase;
}

.coverImage {
  --base--image--max-aspect-ratio: 6 / 9;
}

.link {
  composes: reset-link link from global;
}

.categories {
  color: var(--color--dark-blue);
}
</style>
